/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ComplianceStepResource
 */
export interface ComplianceStepResource {
    /**
     * 
     * @type {string}
     * @memberof ComplianceStepResource
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof ComplianceStepResource
     */
    state: string;
}

/**
 * Check if a given object implements the ComplianceStepResource interface.
 */
export function instanceOfComplianceStepResource(value: object): value is ComplianceStepResource {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    return true;
}

export function ComplianceStepResourceFromJSON(json: any): ComplianceStepResource {
    return ComplianceStepResourceFromJSONTyped(json, false);
}

export function ComplianceStepResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplianceStepResource {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'state': json['state'],
    };
}

export function ComplianceStepResourceToJSON(value?: ComplianceStepResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'label': value['label'],
        'state': value['state'],
    };
}

